export default "/50f517735fec46580f19aae3e56e9fe21614ea75/78489dd5fe22b2b724f99f5861a7cee7.svg";